import * as React from "react"
import { ModalOpenProductOverlay } from "./modal-open-overlay"
import { useRecoilValue } from "recoil"
import { viewDependingLayoutAtom } from "../../../../recoil/atoms/view"
import { pipParamsSelector } from "../../../../recoil/atoms/pictureInPicture"
import { productOverlaySelector } from "../../../../recoil/atoms/product-overlay"
import { GAP_BETWEEN_OVERLAY_AND_BOTTOM_EDGE } from "../../../../constants"
import { useWatchParty } from "../../../../hooks/useWatchParty"
import useWindowSize from "../../../../hooks/useWindowSize"
import layoutStates from "../../../../recoil/atoms/layout"

interface ProductOverlayProps {
  width: number
  height: number
  isWithoutTitle?: boolean
  isFullScreen?: boolean
}

export const ProductOverlay: React.FC<ProductOverlayProps> = ({
  width,
  height,
  isWithoutTitle,
  isFullScreen
}) => {
  const { screenSize } = useWindowSize()
  const { isLandscape, isMobile, isTablet } = useRecoilValue(
    viewDependingLayoutAtom
  )
  const { isActivePiP, isRedirected } = useRecoilValue(pipParamsSelector)
  const { isOpen } = useRecoilValue(productOverlaySelector)
  const isSmallScreen = React.useMemo<boolean>(() => width - 90 < 450, [width])
  const { isWatchParty, isModPresentImage } = useWatchParty()
  const isFloatingDivActive = useRecoilValue(layoutStates.isFloatingDivActive)

  const isLargeScreen = React.useMemo<boolean>(
    () =>
      (isWithoutTitle !== undefined ? !isWithoutTitle : width - 90 > 700) &&
      !isLandscape,
    [isLandscape, isWithoutTitle, width]
  )

  const heightContainer = React.useMemo<string>(() => {
    if (isWatchParty) {
      return isTablet || isMobile
        ? isModPresentImage
          ? `${height}px`
          : `calc(${height}px - 5px)`
        : `${
            height -
            (isModPresentImage ? 0 : 7) -
            GAP_BETWEEN_OVERLAY_AND_BOTTOM_EDGE * 2
          }px`
    }
    return isTablet || isMobile
      ? `${height}px`
      : `${height - GAP_BETWEEN_OVERLAY_AND_BOTTOM_EDGE * 2}px`
  }, [height, isMobile, isModPresentImage, isTablet, isWatchParty])

  const widthContainer = React.useMemo<string>(() => {
    return isTablet || isMobile ? `${width}px` : `calc(${width}px - 60px)`
  }, [isMobile, isTablet, width])

  const containerStyles: React.CSSProperties = React.useMemo(() => {
    return {
      display: isFloatingDivActive
        ? "flex"
        : !(isActivePiP && !isRedirected)
        ? "none"
        : "flex",
      height: isFullScreen
        ? screenSize.height - 100
        : isMobile && isFloatingDivActive
        ? height
        : heightContainer,
      width: isFullScreen ? screenSize.width - 100 : widthContainer,
      maxWidth: screenSize.width,
      padding:
        isMobile && isLandscape
          ? "1.5rem 0.5rem 1.5rem 0.5rem"
          : isMobile && "0.5rem"
    }
  }, [
    height,
    heightContainer,
    isActivePiP,
    isLandscape,
    isMobile,
    isRedirected,
    screenSize.width,
    widthContainer,
    isFloatingDivActive,
    isFullScreen
  ])

  return (
    <>
      {isOpen && (
        <ModalOpenProductOverlay
          isHistoryProduct={false}
          containerStyles={containerStyles}
          isSmallScreen={isSmallScreen}
          isLargeScreen={isLargeScreen}
        />
      )}
    </>
  )
}
